
(window.slate = window.slate || {}),
    (window.theme = window.theme || {}),
    (slate.a11y = {
        pageLinkFocus: function (t) {
            function e() {
                t.first().removeClass(i).removeAttr("tabindex");
            }
            var i = "js-focus-hidden";
            t.first().attr("tabIndex", "-1").focus().addClass(i).one("blur", e);
        },
        focusHash: function () {
            var t = window.location.hash;
            t && document.getElementById(t.slice(1)) && this.pageLinkFocus($(t));
        },
        bindInPageLinks: function () {
            $("a[href*=#]").on(
                "click",
                function (t) {
                    this.pageLinkFocus($(t.currentTarget.hash));
                }.bind(this)
            );
        },
        trapFocus: function (t) {
            var e = t.eventNamespace ? "focusin." + t.eventNamespace : "focusin";
            t.$elementToFocus || (t.$elementToFocus = t.$container),
                t.$container.attr("tabindex", "-1"),
                t.$elementToFocus.focus(),
                $(document).on(e, function (e) {
                    t.$container[0] === e.target || t.$container.has(e.target).length || t.$container.focus();
                });
        },
        removeTrapFocus: function (t) {
            var e = t.namespace ? "focusin." + t.namespace : "focusin";
            t.$container && t.$container.length && t.$container.removeAttr("tabindex"), $(document).off(e);
        },
    }),
    (slate.cart = {
        cookiesEnabled: function () {
            var t = navigator.cookieEnabled;
            return t || ((document.cookie = "testcookie"), (t = -1 !== document.cookie.indexOf("testcookie"))), t;
        },
    }),
    (slate.utils = {
        findInstance: function (t, e, i) {
            for (var a = 0; a < t.length; a++) if (t[a][e] === i) return t[a];
        },
        removeInstance: function (t, e, i) {
            for (var a = t.length; a--; )
                if (t[a][e] === i) {
                    t.splice(a, 1);
                    break;
                }
            return t;
        },
        compact: function (t) {
            for (var e = -1, i = null == t ? 0 : t.length, a = 0, r = []; ++e < i; ) {
                var o = t[e];
                o && (r[a++] = o);
            }
            return r;
        },
        defaultTo: function (t, e) {
            return null == t || t !== t ? e : t;
        },
    }),
    (slate.rte = {
        wrapTable: function () {
            $(".rte table").wrap('<div class="rte__table-wrapper"></div>');
        },
        iframeReset: function () {
            var t = $('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]'),
                e = t.add(".rte iframe#admin_bar_iframe");
            t.each(function () {
                $(this).wrap('<div class="rte__video-wrapper"></div>');
            }),
                e.each(function () {
                    this.src = this.src;
                });
        },
    }),
    (slate.Currency = (function () {
        function t(t, i) {
            function a(t, e, i, a) {
                if (((e = slate.utils.defaultTo(e, 2)), (i = slate.utils.defaultTo(i, ",")), (a = slate.utils.defaultTo(a, ".")), isNaN(t) || null == t)) return 0;
                t = (t / 100).toFixed(e);
                var r = t.split("."),
                    o = r[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i),
                    n = r[1] ? a + r[1] : "";
                return o + n;
            }
            "string" == typeof t && (t = t.replace(".", ""));
            var r = "",
                o = /\{\{\s*(\w+)\s*\}\}/,
                n = i || e;
            switch (n.match(o)[1]) {
                case "amount":
                    r = a(t, 2);
                    break;
                case "amount_no_decimals":
                    r = a(t, 0);
                    break;
                case "amount_with_comma_separator":
                    r = a(t, 2, ".", ",");
                    break;
                case "amount_no_decimals_with_comma_separator":
                    r = a(t, 0, ".", ",");
                    break;
                case "amount_no_decimals_with_space_separator":
                    r = a(t, 0, " ");
            }
            return n.replace(o, r);
        }
        var e = "${{amount}}";
        return { formatMoney: t };
    })()),
    (slate.Image = (function () {
        function t(t, e) {
            "string" == typeof t && (t = [t]);
            for (var i = 0; i < t.length; i++) {
                var a = t[i];
                this.loadImage(this.getSizedImageUrl(a, e));
            }
        }
        function e(t) {
            new Image().src = t;
        }
        function i(t) {
            var e = t.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);
            return e ? e[1] : null;
        }
        function a(t, e) {
            if (null === e) return t;
            if ("master" === e) return this.removeProtocol(t);
            var i = t.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
            if (i) {
                var a = t.split(i[0]),
                    r = i[0];
                return this.removeProtocol(a[0] + "_" + e + r);
            }
            return null;
        }
        function r(t) {
            return t.replace(/http(s)?:/, "");
        }
        return { preload: t, loadImage: e, imageSize: i, getSizedImageUrl: a, removeProtocol: r };
    })()),
    (slate.Variants = (function () {
        function t(t) {
            (this.$container = t.$container),
                (this.product = t.product),
                (this.singleOptionSelector = t.singleOptionSelector),
                (this.originalSelectorId = t.originalSelectorId),
                (this.enableHistoryState = t.enableHistoryState),
                (this.currentVariant = this._getVariantFromOptions()),
                $(this.singleOptionSelector, this.$container).on("change", this._onSelectChange.bind(this));
        }
        return (
            (t.prototype = $.extend({}, t.prototype, {
                _getCurrentOptions: function () {
                    var t = $.map($(this.singleOptionSelector, this.$container), function (t) {
                        var e = $(t),
                            i = e.attr("type"),
                            a = {};
                        return "radio" === i || "checkbox" === i ? (e[0].checked ? ((a.value = e.val()), (a.index = e.data("index")), a) : !1) : ((a.value = e.val()), (a.index = e.data("index")), a);
                    });
                    return (t = slate.utils.compact(t));
                },
                _getVariantFromOptions: function () {
                    var t = this._getCurrentOptions(),
                        e = this.product.variants,
                        i = !1;
                    return (
                        e.forEach(function (e) {
                            var a = !0;
                            e.options;
                            t.forEach(function (t) {
                                a && (a = t.value === e[t.index]);
                            }),
                                a && (i = e);
                        }),
                        i || null
                    );
                },
                _onSelectChange: function () {
                    var t = this._getVariantFromOptions();
                    this.$container.trigger({ type: "variantChange", variant: t }),
                        t && (this._updateMasterSelect(t), this._updateImages(t), this._updatePrice(t), (this.currentVariant = t), this.enableHistoryState && this._updateHistoryState(t));
                },
                _updateImages: function (t) {
                    var e = t.featured_image || {},
                        i = this.currentVariant.featured_image || {};
                    t.featured_image && e.src !== i.src && this.$container.trigger({ type: "variantImageChange", variant: t });
                },
                _updatePrice: function (t) {
                    (t.price === this.currentVariant.price && t.compare_at_price === this.currentVariant.compare_at_price) || this.$container.trigger({ type: "variantPriceChange", variant: t });
                },
                _updateHistoryState: function (t) {
                    if (history.replaceState && t) {
                        var e = window.location.protocol + "//" + window.location.host + window.location.pathname + "?variant=" + t.id;
                        window.history.replaceState({ path: e }, "", e);
                    }
                },
                _updateMasterSelect: function (t) {
                    $(this.originalSelectorId, this.$container)[0].value = t.id;
                },
            })),
            t
        );
    })()),
    (theme.Product = (function () {
        function t(t) {
            this.$container = $(t);
            this.$container.attr("data-section-id");
            (this.settings = {}),
                (this.namespace = ".product"),
                $(e.productJson, this.$container).html() &&
                    ((this.productSingleObject = JSON.parse($(e.productJson, this.$container).html())),
                    (this.settings.imageSize = slate.Image.imageSize($(e.productFeaturedImage, this.$container).attr("src"))),
                    slate.Image.preload(this.productSingleObject.images, this.settings.imageSize),
                    this.initVariants());
        }
        var e = {
            addToCart: "[data-add-to-cart]",
            addToCartText: "[data-add-to-cart-text]",
            comparePrice: "[data-compare-price]",
            comparePriceText: "[data-compare-text]",
            originalSelectorId: "[data-product-select]",
            priceWrapper: "[data-price-wrapper]",
            productFeaturedImage: "[data-product-featured-image]",
            productJson: "[data-product-json]",
            productPrice: "[data-product-price]",
            productThumbs: "[data-product-single-thumbnail]",
            singleOptionSelector: "[data-single-option-selector]",
        };
        return (
            (t.prototype = $.extend({}, t.prototype, {
                initVariants: function () {
                    var t = {
                        $container: this.$container,
                        enableHistoryState: this.$container.data("enable-history-state") || !1,
                        singleOptionSelector: e.singleOptionSelector,
                        originalSelectorId: e.originalSelectorId,
                        product: this.productSingleObject,
                    };
                    (this.variants = new slate.Variants(t)),
                        this.$container.on("variantChange" + this.namespace, this.updateAddToCartState.bind(this)),
                        this.$container.on("variantImageChange" + this.namespace, this.updateProductImage.bind(this)),
                        this.$container.on("variantPriceChange" + this.namespace, this.updateProductPrices.bind(this));
                },
                updateAddToCartState: function (t) {
                    var i = t.variant;
                    return i
                        ? ($(e.priceWrapper, this.$container).removeClass("hide"),
                          void (i.available
                              ? ($(e.addToCart, this.$container).prop("disabled", !1), $(e.addToCartText, this.$container).html(theme.strings.addToCart))
                              : ($(e.addToCart, this.$container).prop("disabled", !0), $(e.addToCartText, this.$container).html(theme.strings.soldOut))))
                        : ($(e.addToCart, this.$container).prop("disabled", !0), $(e.addToCartText, this.$container).html(theme.strings.unavailable), void $(e.priceWrapper, this.$container).addClass("hide"));
                },
                updateProductPrices: function (t) {
                    var i = t.variant,
                        a = $(e.comparePrice, this.$container),
                        r = a.add(e.comparePriceText, this.$container);
                    $(e.productPrice, this.$container).html(slate.Currency.formatMoney(i.price, theme.moneyFormat)),
                        i.compare_at_price > i.price ? (a.html(slate.Currency.formatMoney(i.compare_at_price, theme.moneyFormat)), r.removeClass("hide")) : (a.html(""), r.addClass("hide"));
                },
                updateProductImage: function (t) {
                    var i = t.variant,
                        a = slate.Image.getSizedImageUrl(i.featured_image.src, this.settings.imageSize);
                    $(e.productFeaturedImage, this.$container).attr("src", a);
                },
                onUnload: function () {
                    this.$container.off(this.namespace);
                },
            })),
            t
        );
    })()),
    (theme.customerAddresses = (function () {
        var t = $("#AddressNewForm");
        t.length &&
            (Shopify && new Shopify.CountryProvinceSelector("AddressCountryNew", "AddressProvinceNew", { hideElement: "AddressProvinceContainerNew" }),
            $(".address-country-option").each(function () {
                var t = $(this).data("form-id"),
                    e = "AddressCountry_" + t,
                    i = "AddressProvince_" + t,
                    a = "AddressProvinceContainer_" + t;
                new Shopify.CountryProvinceSelector(e, i, { hideElement: a });
            }),
            $(".address-new-toggle").on("click", function () {
                t.toggleClass("hide");
            }),
            $(".address-edit-toggle").on("click", function () {
                var t = $(this).data("form-id");
                $("#EditAddress_" + t).toggleClass("hide");
            }),
            $(".address-delete").on("click", function () {
                var t = $(this),
                    e = t.data("form-id"),
                    i = t.data("confirm-message");
                confirm(i || "Are you sure you wish to delete this address?") && Shopify.postLink("/account/addresses/" + e, { parameters: { _method: "delete" } });
            }));
    })()),
    (theme.customerLogin = (function () {
        function t(t) {
            t.preventDefault(), i();
        }
        function e() {
            var t = window.location.hash;
            "#recover" === t && i();
        }
        function i() {
            $("#RecoverPasswordForm").toggleClass("hide"), $("#CustomerLoginForm").toggleClass("hide");
        }
        function a() {
            var t = $(".reset-password-success");
            t.length && $("#ResetSuccess").removeClass("hide");
        }
        var r = { recoverPasswordForm: "#RecoverPassword", hideRecoverPasswordLink: "#HideRecoverPasswordLink" };
        $(r.recoverPasswordForm).length && (e(), a(), $(r.recoverPasswordForm).on("click", t), $(r.hideRecoverPasswordLink).on("click", t));
    })()),
    $(document).ready(function () {
        $(".size-chart-open-popup").magnificPopup({ type: "inline", midClick: !0 }),
            $(".return-policy-open-popup").magnificPopup({ type: "inline", midClick: !0 }),
            $("form#create_customer").submit(function (t) {
                $("#CreatePassword").val() !== $("#CreatePasswordConfirmation").val()
                    ? ($(".password_match").fadeIn("slow"), $("#CreatePassword, #CreatePasswordConfirmation").css("border", "2px solid #f00"), t.preventDefault())
                    : ($(".password_match").fadeOut("slow"), $("#CreatePassword, #CreatePasswordConfirmation").removeAttr("style")),
                    $("#Email").val() !== $("#EmailConfirmation").val()
                        ? ($(".email_match").fadeIn("slow"), $("#Email, #EmailConfirmation").css("border", "2px solid #f00"), t.preventDefault())
                        : ($(".email_match").fadeOut("slow"), $("#Email, #EmailConfirmation").removeAttr("style"));
            });
    }),
    (function (t) {
       var globalVar = "";
       var titleSet = [];
       var handleSet = [];
        function e(t, e) {
            (this.url = t), (this.title = e);
        }
        function i(t) {
            (this.title = t), (this.url = null), (this.links = []);
        }
        function a() {
            this.columns = [];
        }
        (e.prototype.toHtml = function (e) {
            var i = t(e);
            i.append("<a href='" + this.url + "'>" + this.title + "</a>");
        }),
            (i.prototype.addLink = function (t, i) {
                return this.links.push(new e(t, i)), !0;
            }),
            (i.prototype.getTitle = function () {
                return this.title;
            }),
            (i.prototype.setTitle = function (t) {
                return (this.title = t.split(">").slice(-1)[0].trim()), !0;
            }),
            (i.prototype.getUrl = function () {
                return this.url;
            }),
            (i.prototype.setUrl = function (t) {
                return (this.url = t), !0;
            }),
            (i.prototype.toHtml = function (e) {
                var i = t(e),
                    a = this.getTitle();

                window.isValue(this.getUrl()) && (a = "<a href='" + this.getUrl() + "'>" + a + "</a>"), i.append('<strong class="hFive">'+ a +'</strong>');
                var r = t("<ul class='vertical_list " + this.title.replace(/\s/g, "") + "'></ul>");
                this.links.forEach(function (t) {
                    t.toHtml(r);
                }),
                    i.append(r);
            }),
            (a.prototype.hasColumn = function (t) {
                return window.isDefined(this.columns[t]);
            }),
            (a.prototype.addColumn = function (t) {
                return this.hasColumn(t) ? !1 : ((this.columns[t] = { linkLists: [] }), !0);
            }),
            (a.prototype.getList = function (t, e) {
                var i = this.columns[t].linkLists[e];
                return window.isUndefined(i) && ((i = { handle: null, url: null }), (this.columns[t].linkLists[e] = i)), i;
            }),
            (a.prototype.addLinkList = function (t, e, i) {
                if (!this.hasColumn(t) || !window.isValue(i)) return !1;
                var a = this.getList(t, e);
                return (a.handle = i), !0;
            }),
            (a.prototype.addListUrl = function (t, e, i) {
                if (!this.hasColumn(t) || !window.isValue(i)) return !1;
                var a = this.getList(t, e);
                return (a.url = i), !0;
            }),
            (a.prototype.setColumnData = function (t, e, i) {
                return this.hasColumn(t) && window.isValue(i) ? ((this.columns[t][e] = i), !0) : !1;
            }),
            (a.prototype.setData = function (t, e) {
                if ("title" === t) return this.setTitle(e);
                var i = t.split("_");
                if (i.length < 3 || "column" !== i[0]) return !1;
                var a = i[1],
                    r = i.slice(2).join("_");
                this.addColumn(a);
                var o = i[i.length - 1] - 1;
                return 0 === r.indexOf("link_list") ? this.addLinkList(a, o, e) : 0 === r.indexOf("list_url") ? this.addListUrl(a, o, e) : this.setColumnData(a, r, e), !0;
            }),
            (a.prototype.getTitle = function () {
                return this.title;
            }),
            (a.prototype.setTitle = function (t) {

                return (this.title = t), !0;
            }),
            (a.prototype.getColumns = function () {
                return this.columns.filter(function (t) {
                    return t;
                });
            }),
            (a.prototype.toHtml = function (e) {
                var i = t(e),
                    a = t("<div class='row'></div>"),
                    r = !1,
                    stro = 0;
                    var  lstTitle = '';
                    var  lstUrl = '';
                  
                this.getColumns().forEach(function (e) {
                   // var checkP = $('#titlehititle').text();
                	//console.log(checkP);
                
                    var i = t("<div class='column'></div>");
                    if ("featured_image" === e.contents && window.isValue(e.featured_image)) {
                      console.log(e.featured_image_alt);
                        var o = e.featured_image,
                            po = e.featured_image_alt,
                            n = t("<ul class='vertical_list'></ul>"),
                            s = t('<img src="' + o + '" alt="' + po + '" />');
                       window.isValue(e.featured_link) && (s = t("<a href='" + e.featured_link + "'></a>").append(s)), i.append(n.append(s));

                    } else
                        e.linkLists.forEach(function (t) {
                            
                   
                            if (!rdbMegaMenu.hasList(t.handle)) {
                                handleSet.forEach(function(item,index)
                                {
                                   if(item == t.handle)
                                   {
                                    var indexOfitem = index;
                                    titleSet.forEach(function(item,index)
                                    {
                                        if(titleSet.indexOf(item) == indexOfitem)
                                        { 
                                            var myItemTitle = myFunc(item);
                                      i.append("<h5><a href='" + t.url + "'>" + myItemTitle + "</a></h5>");
                                    
                                        }
                                    });
                                   }
                                }); 
                                 return !1;
                            }

                            var e = rdbMegaMenu.getList(t.handle);
                            e.setUrl(t.url), e.toHtml(i);
                        });
                    a.append(i), i.children().length && (r = !0);
                }),
                    r && (i.append(a), i.addClass("rdb-nav__dropdown--has-lists"));
            }),
            (window.rdbMegaMenu = (function () {
                var t = [],
                    e = [];
                return {
                    addBlock: function (e, i) {

                        t[e] = new a(i);

                        for (var r in i) t[e].setData(r, i[r]);
                    },
                    hasList: function (t) {
                        return window.isDefined(e[t]);
                    },
                    addList: function (t) {
                        return this.hasList(t) ? !1 : ((e[t] = new i(t)), !0);
                    },
                    addListLink: function (t, i, a) {
                        this.addList(t), e[t].addLink(i, a);
                    },
                    setListTitle: function (t, i) {
                    
                      if(this.hasList(t)) 
                      {
                        return void e[t].setTitle(i)
                    }  else
                    { 
                      titleSet.push(i);
                      handleSet.push(t);
                    }
                    },
                    getList: function (t) {
                        return this.hasList(t) ? e[t] : !1;
                    },
                    getBlock: function (e) {
                        return window.isUndefined(t[e]) ? new a() : t[e];
                    },
                };
            })());
    })(window.jQuery),
    (function (t, e) {
        (e.ShopTheLook = function (e, i) {
            (this.config = i), (this.$link = t(e)), this.init();
        }),
            (e.ShopTheLook.prototype = {
                constructor: e.ShopTheLook,
                init: function () {
                    window.isValue(this.$link) && this.$link.click(function () {}.bind(this));
                },
                getAssociatedProductByHandle: function (t) {
                    if (!window.isValue(t)) return null;
                    for (var e = 0; e < this.config.associated.length; e++) {
                        var i = this.config.associated[e];
                        if (i.handle === t) return i;
                    }
                    return null;
                },
                gridItemFormHtml: function () {
                    var e = {
                            productForm:
                                '<div class="product-form"><form class="add_product_form" data-form-id="{{ ADD_PRODUCT_FORM_ID }}" data-product-handle="{{productHandle}}" action="/cart/add" method="post" enctype="multipart/form-data">{{productFormHtml}}<div class="product-add-success hide">Item Added!</div></form></div>',
                            productFormInner: '<div class="product-add-form"></div>',
                            productFormSubmit:
                                '<div class="buttons_row"><div class="input-validation">error message</div><input data-action="SHOPLOOK_ADD_TO_CART_CLICK" class="add_product_submit" type="submit" name="" value="Add To Bag"></div>',
                        },
                        i = this.config.featured,
                        a = t(e.productFormInner),
                        r = t(e.productFormSubmit),
                        o = t('<div class="options_row"></div>'),
                        n = i.options.sort(function (t, e) {
                            return t.name > e.name ? 1 : e.name > t.name ? -1 : 0;
                        }),
                        s = t('<select name="id" class="no-js" style="display: none;"></select>');
                    s.append(t('<option value=""></option>'));
                    for (var d = 0; d < i.variants.length; d++) {
                        var c = i.variants[d],
                            l = t("<option/>", { value: c.id, text: c.title, selected: 1 === i.variants.length });
                        c.available === !1 && l.attr("data-stock", "no-stock"), s.append(l);
                    }
                    if ((o.append(s), 1 !== i.variants.length))
                        for (var u = 0; u < n.length; u++) {
                            var p = n[u],
                                m = t('<select name="' + p.name + '" data-option-position="' + p.position + '"></select>');
                            "Color" !== p.name && m.append(t('<option value="" disabled selected hidden>' + p.name.toUpperCase() + "</option>")),
                                t.each(p.values, function (e, i) {
                                    m.append(t("<option/>", { value: i, text: i, selected: "Color" === p.name }));
                                });
                            var h = t('<div class="select-wrapper" data-option="' + p.name + '"></div>');
                            h.append(m), o.append(h);
                        }
                    a.append(o), a.append(r);
                    var f = e.productForm.replace(/{{productFormHtml}}/g, a.html()).replace(/{{productHandle}}/g, i.handle);
                    return t(f);
                },
                modalHtml: function () {
                    var e = t('<div id="shop-the-look-modal" class="grid"></div>'),
                        i = {
                            productPriceHtml: '<div class="product-price"><span class="price">{{productPrice}}</span></div>',
                            productSalePriceHtml: '<div class="product-price"><span class="price-compare">{{productOriginalPrice}}</span><span class="price-sale">{{productSalePrice}}</span></div>',
                            featuredProductHtml:
                                '<div class="grid__item large--one-whole shoplook__featured-wrapper"><button title="Close (Esc)" type="button" class="mfp-close">x</button><div class="shoplook__featured"><h1 class="product-name">{{productName}}</h1><div class="product-price">{{productPriceHtml}}</div><div class="bag-confirmation"><a class="pink button" href="/cart">GO TO MY BAG</a></div></div></div>',
                            featuredImageHtml: '<div class="grid__item large--one-half medium-down--three-quarters shoplook__featured-image"><a href="{{productUrl}}"><img src="{{imageUrl}}" alt="{{imageTitle}}" width="532" /></a></div>',
                            associatedProductHtml:
                                '<div class="shoplook__associated grid__item medium-down--one-half"><div class="shoplook__associated-head"><div class="shoplook__associated-image"><a href="{{productUrl}}"><img src="{{imageUrl}}" alt="{{imageTitle}}" width="163" /></a></div></div><div class="shoplook__associated-content"><div class="shoplook__associated-pc-inner"><h5 class="product-name"><a href="{{productUrl}}">{{productName}}</a></h5><div class="product-vendor hide">{{productVendor}}</div><div class="product-price">{{productPriceHtml}}</div><div class="product-form"><form class="add_product_form" data-form-id="{{ ADD_PRODUCT_FORM_ID }}" data-product-handle="{{productHandle}}" action="/cart/add" method="post" enctype="multipart/form-data">{{productFormHtml}}<div class="product-add-success hide">Item Added!</div></form></div></div></div></div>',
                            associatedProductFormHtml: '<div class="product-add-form"></div>',
                            associatedProductFormSubmitHtml:
                                '<div class="buttons_row"><div class="input-validation">error message</div><input data-action="SHOPLOOK_ADD_TO_CART_CLICK" class="add_product_submit" type="submit" name="" value="Add To Bag"></div>',
                        },
                        a = this.config.featured,
                        r = i.productPriceHtml.replace(/{{productPrice}}/g, a.price);
                    window.isValue(a.originalPrice) && a.price < a.originalPrice && (r = i.productSalePriceHtml.replace(/{{productOriginalPrice}}/g, a.originalPrice).replace(/{{productSalePrice}}/g, a.price));
                    var o = i.featuredProductHtml.replace(/{{productName}}/g, a.title).replace(/{{productPriceHtml}}/g, r);
                    e.append(o);
                    var n = i.featuredImageHtml
                        .replace(/{{productUrl}}/g, "/products/" + a.handle)
                        .replace(/{{imageUrl}}/g, a.image.url)
                        .replace(/{{imageTitle}}/g, a.image.title);
                    e.append(n);
                    for (var s = t('<div class="grid__item large--one-half medium-down--one-whole shoplook__associated-wrapper"></div>'), d = 0; d < this.config.associated.length; d++) {
                        var c = this.config.associated[d],
                            l = i.productPriceHtml.replace(/{{productPrice}}/g, c.price);
                        window.isValue(c.originalPrice) && c.price < c.originalPrice && (l = i.productSalePriceHtml.replace(/{{productOriginalPrice}}/g, c.originalPrice).replace(/{{productSalePrice}}/g, c.price));
                        var u = t(i.associatedProductFormHtml),
                            p = t(i.associatedProductFormSubmitHtml),
                            m = c.options.sort(function (t, e) {
                                return t.name > e.name ? 1 : e.name > t.name ? -1 : 0;
                            }),
                            h = t('<select name="id" class="no-js" style="display: none;"></select>');
                        h.append(t('<option value=""></option>'));
                        for (var f = 0; f < c.variants.length; f++) {
                            var v = c.variants[f],
                                g = t("<option/>", { value: v.id, text: v.title, selected: 1 === c.variants.length });
                            v.available === !1 && g.attr("data-stock", "no-stock"), h.append(g);
                        }
                        if ((u.append(h), 1 !== c.variants.length))
                            for (var w = 0; w < m.length; w++) {
                                var _ = m[w],
                                    C = t('<select name="' + _.name + '" data-option-position="' + _.position + '"></select>');
                                C.append(t('<option value="" disabled selected hidden>' + _.name.toUpperCase() + "</option>")),
                                    t.each(_.values, function (e, i) {
                                        C.append(t("<option/>", { value: i, text: i, selected: "Color" === _.name }));
                                    });
                                var $ = t('<div class="select-wrapper" data-option="' + _.name + '"></div>');
                                $.append(C), u.append($);
                            }
                        u.append(p);
                        var y = i.associatedProductHtml
                            .replace(/{{imageUrl}}/g, c.image.url)
                            .replace(/{{imageTitle}}/g, c.image.title)
                            .replace(/{{productName}}/g, c.title)
                            .replace(/{{productUrl}}/g, "/products/" + c.handle)
                            .replace(/{{productVendor}}/g, c.vendor)
                            .replace(/{{productHandle}}/g, c.handle)
                            .replace(/{{productPriceHtml}}/g, l)
                            .replace(/{{productFormHtml}}/g, u.html());
                        s.append(y);
                    }
                    return e.append(s), e;
                },
                openModal: function () {
                    var e = this,
                        i = this.modalHtml(),
                        a = [];
                    a.push({ src: i }),
                        $.magnificPopup.open({
                            items: a,
                            callbacks: {
                                open: function () {
                                    var e = $.magnificPopup.instance,
                                        i = t(e.contentContainer);
                                    i.on(
                                        "click",
                                        "[data-action=SHOPLOOK_ADD_TO_CART_CLICK]",
                                        function (e) {
                                            e.preventDefault();
                                            var i = t(e.target).closest("form");
                                            this.addToCart(i);
                                        }.bind(this)
                                    ),
                                        window.setTimeout(
                                            function () {
                                                var e = $.magnificPopup.instance,
                                                    i = t(e.contentContainer);
                                                this.watchVariants(i);
                                                var a = t(".shoplook__featured-image").height();
                                                a && t(".shoplook__associated-wrapper").css("max-height", a);
                                            }.bind(this),
                                            1e3
                                        );
                                }.bind(e),
                                resize: function () {
                                    var e = t(".shoplook__featured-image").height();
                                    e && t(".shoplook__associated-wrapper").css("max-height", e);
                                },
                            },
                        });
                },
                addQuickOptions: function () {
                    var e = this,
                        i = this.gridItemFormHtml(),
                        a = t('.products_grid_item[data-handle="' + this.config.featured.handle + '"]'),
                        r = a.find(".info");
                    r.append(i),
                        e.watchVariants(a),
                        a.on(
                            "click",
                            "[data-action=SHOPLOOK_ADD_TO_CART_CLICK]",
                            function (e) {
                                e.preventDefault();
                                var i = t(e.target).closest("form");
                                this.addToCart(i);
                            }.bind(this)
                        );
                },
                watchVariants: function (i) {
                    var a = this,
                        r = i.find("select[name=id]"),
                        o = i.find("select").not(r);
                    o.on("change", function () {
                        for (var i = t(this).closest("form"), r = [], o = i.find("select"), n = 0; n < o.length; n++) {
                            var s = t(o[n]),
                                d = s.attr("data-option-position");
                            window.isUndefined(d) || (r[d - 1] = s.val());
                        }
                        r = r.filter(function (t) {
                            return t;
                        });
                        var c = i.attr("data-product-handle"),
                            l = a.getAssociatedProductByHandle(c);
                        if (r.length !== l.options.length) return !1;
                        i.find(".buttons_row").removeClass("hide"),
                            i.find(".product-add-success").addClass("hide"),
                            i.find(".input-validation").removeClass("error"),
                            t.each(i.find(".select-wrapper select"), function (e, i) {
                                var a = t(i);
                                window.isValue(a.val()) && a.removeClass("error");
                            });
                        for (var u, p = 0; p < l.variants.length; p++) {
                            var m = l.variants[p];
                            JSON.stringify(r) === JSON.stringify(m.options) && (u = m);
                        }
                        if (!window.isValue(u)) return !1;
                        var h = u.price || 0;
                        i.find(".product-price .price").html(e.formatMoney(h, "${{amount_no_decimals}}"));
                        var f = i.find("input.add_product_submit"),
                            v = !u.available;
                        return v ? (f.prop("disabled", 1), f.addClass("no-stock"), f.val("Out Of Stock"), !1) : (f.prop("disabled", !1), f.removeClass("no-stock"), f.val("Add To Bag"), void i.find("[name=id]").val(u.id));
                    });
                },
                addToCart: function (i) {
                    var a = i.find("[name=id]").val(),
                        r = i.find("[name=quantity]").val() || 1,
                        o = [];
                    t.each(i.find(".select-wrapper select"), function (e, i) {
                        var a = t(i);
                        window.isValue(a.val()) ? a.removeClass("error") : (a.addClass("error"), o.push(a.attr("name")));
                    });
                    var n = i.find(".input-validation");
                    if ((o.length ? (o.push(""), n.addClass("error"), n.text(o.join(" is required. "))) : n.removeClass("error"), !window.isValue(a))) return i.find("input.add_product_submit").prop("disabled", 1), !1;
                    var s = {
                        type: "POST",
                        url: "/cart/add.js",
                        data: "quantity=" + r + "&id=" + a,
                        dataType: "json",
                        success: function (e) {
                            window.isValue(e) &&
                                (i.find(".buttons_row").addClass("hide"),
                                i.find(".product-add-success").removeClass("hide"),
                                t.getJSON("/cart.js", function (e) {
                                    t(".cart_summary_icon span").text(e.item_count);
                                }));
                        },
                        error: function (t, i) {
                            e.onError(t, i);
                        },
                    };
                    t.ajax(s);
                },
            });
    })(window.jQuery, window.Shopify),
    (function (t, e) {
        function i(t, e) {
            (this.popupId = t), (this.cookieName = e);
        }
        (i.prototype.createCookie = function (t, e, i) {
            var a;
            if (i) {
                var r = new Date();
                r.setTime(r.getTime() + 1e3 * i), (a = "; expires=" + r.toUTCString());
            } else a = "";
            document.cookie = encodeURIComponent(t) + "=" + encodeURIComponent(e) + a + "; path=/";
        }),
            (i.prototype.readCookie = function (t) {
                for (var e = encodeURIComponent(t) + "=", i = document.cookie.split(";"), a = 0; a < i.length; a++) {
                    for (var r = i[a]; " " === r.charAt(0); ) r = r.substring(1, r.length);
                    if (0 === r.indexOf(e)) return decodeURIComponent(r.substring(e.length, r.length));
                }
                return null;
            }),
            (i.prototype.openNewsletterForm = function () {
                var i = this.readCookie(this.cookieName);
                if (navigator.cookieEnabled && !i) {
                    t("#emarsys-modal").show();
                    var a = this.popupId;
                    e.openTargetElement("[data-popup-id=" + a + "]", function () {
                        t("body").attr("data-popup-modal-context", a);
                    }),
                        this.createCookie(this.cookieName, "true", 604800);
                }
            }),
            (window.emarsysClubSignup = new i("EMARSYS_VIP_SIGNUP", "emarsys-vip-shown")),
            window.emarsysClubSignup.openNewsletterForm();
    })(window.jQuery, window.aPopup),
    (function (t, e, i) {
        (e.EmarsysFooterSignup = function (t, e, i) {
            (this.formId = t), (this.popupId = e), (this.cookieName = i), (this.error = ""), this.init();
        }),
            (e.EmarsysFooterSignup.prototype.init = function () {
                t(this.formId).submit(
                    function (t) {
                        return this.validate() ? (this.createCookie(this.cookieName, "true", 604800), !0) : (t.preventDefault(), alert(this.error), !1);
                    }.bind(this)
                ),
                    this.showSuccess();
            }),
            (e.EmarsysFooterSignup.prototype.createCookie = function (t, e, i) {
                var a;
                if (i) {
                    var r = new Date();
                    r.setTime(r.getTime() + 1e3 * i), (a = "; expires=" + r.toUTCString());
                } else a = "";
                document.cookie = encodeURIComponent(t) + "=" + encodeURIComponent(e) + a + "; path=/";
            }),
            (e.EmarsysFooterSignup.prototype.clearCookie = function (t) {
                this.createCookie(t, "false", -604800);
            }),
            (e.EmarsysFooterSignup.prototype.readCookie = function (t) {
                for (var e = encodeURIComponent(t) + "=", i = document.cookie.split(";"), a = 0; a < i.length; a++) {
                    for (var r = i[a]; " " === r.charAt(0); ) r = r.substring(1, r.length);
                    if (0 === r.indexOf(e)) return decodeURIComponent(r.substring(e.length, r.length));
                }
                return null;
            }),
            (e.EmarsysFooterSignup.prototype.validate = function () {
                var e = t(this.formId),
                    i = e.find('input[name="inp_3"]').val();
                if ("" === i || !window.isValue(i)) return (this.error = "E-Mail: Please enter a valid e-mail address!\n"), !1;
                var a = /^(.+)@(.+)$/,
                    r = '\\(\\)<>@,;:\\\\\\"\\.\\[\\]',
                    o = "[^\\s" + r + "]",
                    n = '("[^"]*")',
                    s = /^\[(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3})$/,
                    d = o + "+",
                    c = "(" + d + "|" + n + ")",
                    l = new RegExp("^" + c + "(\\." + c + ")*$"),
                    u = new RegExp("^" + d + "(\\." + d + ")*$"),
                    p = i.match(a);
                if (null == p) return (this.error = "E-Mail: Please enter a valid e-mail address!\n"), !1;
                var m = p[1],
                    h = p[2];
                if (null == m.match(l)) return (this.error = "E-Mail: Please enter a valid e-mail address!\n"), !1;
                var f = h.match(s);
                if (null != f) {
                    for (var v = 1; 4 >= v; v++) if (f[v] > 255) return (this.error = "E-Mail: Please enter a valid e-mail address!\n"), !1;
                    return !0;
                }
                var g = h.match(u);
                if (null == g) return (this.error = "E-Mail: Please enter a valid e-mail address!\n"), !1;
                var w = new RegExp(d, "g"),
                    _ = h.match(w),
                    C = _.length;
                return 2 > C ? ((this.error = "E-Mail: Please enter a valid e-mail address!\n"), !1) : !0;
            }),
            (e.EmarsysFooterSignup.prototype.showSuccess = function () {
                var e = this.readCookie(this.cookieName);
                if (navigator.cookieEnabled && e) {
                    var a = this.popupId;
                    i.openTargetElement("[data-popup-id=" + a + "]", function () {
                        t("body").attr("data-popup-modal-context", a);
                    }),
                        this.clearCookie(this.cookieName);
                }
            });
    })(window.jQuery, window.Shopify, window.aPopup);
   function myFunc(o3)
            {
                var tutut = o3;
               tutut = tutut.split(">").slice(-1)[0].trim();
             return tutut;
            } 
